import { NavLink, Outlet, useNavigate } from "react-router";
import { useAuth } from "../lib/auth";

const NAV = [
  { to: "/stories", label: "Public Stories" },
  { to: "/my-stories", label: "My Stories" },
  { to: "/playing", label: "Playing" },
  { to: "/profile", label: "Profile" },
];

export function Shell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function onLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">Story AI</div>
        <nav className="nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="account">
            <div className="account-name">{user?.displayName}</div>
            <div className="account-email muted">{user?.email}</div>
          </div>
          <button type="button" className="btn btn-ghost" onClick={onLogout}>
            Log out
          </button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
